import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    strength: { type: Number, default: 0.3 }
  }

  connect() {
    this.handleMouseMove = this.onMouseMove.bind(this)
    this.handleMouseLeave = this.onMouseLeave.bind(this)
    this.element.addEventListener('mousemove', this.handleMouseMove)
    this.element.addEventListener('mouseleave', this.handleMouseLeave)
  }

  disconnect() {
    this.element.removeEventListener('mousemove', this.handleMouseMove)
    this.element.removeEventListener('mouseleave', this.handleMouseLeave)
  }

  onMouseMove(event) {
    const rect = this.element.getBoundingClientRect()
    const centerX = rect.left + rect.width / 2
    const centerY = rect.top + rect.height / 2
    const deltaX = (event.clientX - centerX) * this.strengthValue
    const deltaY = (event.clientY - centerY) * this.strengthValue

    this.element.style.transform = `translate(${deltaX}px, ${deltaY}px)`
    this.element.style.transition = 'transform 0.1s ease-out'
  }

  onMouseLeave() {
    this.element.style.transform = 'translate(0, 0)'
    this.element.style.transition = 'transform 0.4s ease-out'
  }
}
